module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/private-room-icon-39d2cc6d8f1668f9d1e3b7ad15b082ab.png";